<div class="scrollbar-x">
  <div class="pt-1" style="width: 100%">
    <button
      type="button"
      class="btn btn-sm border border-primary rounded-pill ml-1 mb-2"
      *ngFor="let filtro of filters || (tableFilterService.filters$ | async)"
      [ngClass]="{
        'btn-blue': filtro.active,
        'btn-light': !filtro.active
      }"
      (click)="filtro.action()"
      [disabled]="filtro.active"
    >
      <div class="d-flex flex-row align-items-center">
        {{ filtro.text }}
        <span class="badge badge-info ml-1">{{ filtro.badge }}</span>
      </div>
    </button>
  </div>
</div>
